export interface CreateFieldSectionPayload {
  fieldSectionName: string;
  fieldSectionType: FieldSectionType;
  fieldSectionSubType?: FieldSectionSubType;
  private?: boolean;
}

export enum FieldSectionType {
  Project = 'PROJECT',
  ProjectPhase = 'PROJECT_PHASE',
  Task = 'TASK',
  Users = 'USERS',
  Financial = 'FINANCIAL',
  Sprint = 'SPRINT',
  Company = 'COMPANY',
  Timeoff = 'TIMEOFF',
  Invoice = 'INVOICE',
  CreditNote = 'CREDIT_NOTE',
  Budget = 'PROJECT_FINANCIALS_BUDGET',
  Epic = 'EPIC',
  Backlog = 'BACKLOG',
  TimeEntry = 'TIME_ENTRY',
  Expense = 'EXPENSE',
  ResourceAllocation = 'RESOURCE_ALLOCATION',
  Sheet = 'SHEET',
  Reports = 'REPORTS',
}

export enum FieldSectionSubType {
  Default = 'DEFAULT',
  Skill = 'SKILL',
  ExternalUser = 'EXTERNAL_TEAM_MEMBER',
  InvoiceProject = 'INVOICE_PROJECT',
}

export interface FieldSection extends CreateFieldSectionPayload {
  fieldSectionId: number;
  default: boolean;
  fixed: boolean;
  createdBy: number;
  fieldOrder: number[];
  readUserGroupIds?: number[] | null;
  writeUserGroupIds?: number[] | null;
  sectionOrder: number;
}

export enum FieldTypeDisplay {
  Level = 'LEVEL',
}
